module.exports = __webpack_public_path__ + "img/menu_big_00.2a760b84.png";